import React, { useEffect, useState, useMemo } from "react";
import { useHistory } from "react-router-dom";
import { format as dateFormat, add as dateAdd } from "date-fns";
import { Modal } from "react-bootstrap";
import {
  getDeliveryHistory,
  getExportOrderHistory,
  voidOrder as voidOrderEndpoint,
  getLabelsForMultipleDeliveries,
} from "../../services/deliveryService";
import axios from "axios";
import handleApiError from "../../helpers/handleApiError";
import {
  BsCardList,
  BsList,
  BsFillGridFill,
  BsPlusSquare,
  BsArrowRepeat,
} from "react-icons/bs";
import { formatDate } from "../../helpers/utilities";
import { Helmet } from "react-helmet";
import { defaultTitle } from "../../config";
import OrderHistoryList from "./OrderHistoryList";
import { isClient } from "../../services/accountService";

const dummyOrders = [
  {
    deliveryId: "304140123",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "304140123",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "304140123",
    invoiceNumber: "3403503252RT",
    amount: 900.0,
    codAmount: 900.0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: true,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "36321360121",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "304140121",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 81.0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: true,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "304140121",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "304140121",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "304140121",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "304140121",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "304140121",
    invoiceNumber: "3403503252RT",
    amount: 3200.0,
    codAmount: 3200.0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: true,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "304140121",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "304140121",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "304140123",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "304140123",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "304140121",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryId: "3501531531",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "304140121",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "304140121",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryId: "3501531531",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "304140121",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryId: "3501531531",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "304140121",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryId: "3501531531",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "304140121",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryId: "3501531531",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "36316316171",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryId: "3501531531",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "347275235",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryId: "3501531531",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "304140121",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryId: "3501531531",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "304140121",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryId: "3501531531",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "304140121",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryId: "3501531531",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "304140121",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryId: "3501531531",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "304140121",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryId: "3501531531",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "347275235",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryId: "3501531531",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "304140121",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryId: "3501531531",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "304140121",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryId: "3501531531",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "304140121",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryId: "3501531531",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "304140121",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryId: "3501531531",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "304140121",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryId: "3501531531",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "347275235",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryId: "3501531531",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "304140121",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryId: "3501531531",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "304140121",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryId: "3501531531",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "304140121",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryId: "3501531531",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "304140121",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryId: "3501531531",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "304140121",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryId: "3501531531",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "347275235",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryId: "3501531531",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "304140121",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryId: "3501531531",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "304140121",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryId: "3501531531",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "304140121",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryId: "3501531531",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "304140121",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryId: "3501531531",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "304140121",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryId: "3501531531",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "347275235",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryId: "3501531531",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "304140121",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryId: "3501531531",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "304140121",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryId: "3501531531",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "304140121",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryId: "3501531531",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "304140121",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryId: "3501531531",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "304140121",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryId: "3501531531",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "347275235",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryId: "3501531531",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "304140121",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryId: "3501531531",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "304140121",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryId: "3501531531",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "304140121",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryId: "3501531531",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "304140121",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryId: "3501531531",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "304140121",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryId: "3501531531",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "347275235",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryId: "3501531531",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "304140121",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryId: "3501531531",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "304140121",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryId: "3501531531",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "304140121",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryId: "3501531531",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "304140121",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryId: "3501531531",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "304140121",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryId: "3501531531",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "304140121",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryId: "3501531531",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "304140121",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryId: "3501531531",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "347275235",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryId: "3501531531",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "304140121",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryId: "3501531531",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "304140121",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryId: "3501531531",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "304140121",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryId: "3501531531",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "304140121",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryId: "3501531531",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "304140121",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryId: "3501531531",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "304140121",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryId: "3501531531",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "304140121",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryId: "3501531531",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "347275235",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryId: "3501531531",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "304140121",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryId: "3501531531",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "304140121",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryId: "3501531531",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "304140121",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryId: "3501531531",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "304140121",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryId: "3501531531",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "304140121",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryId: "3501531531",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "304140121",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryId: "3501531531",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "304140121",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryId: "3501531531",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "347275235",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryId: "3501531531",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "304140121",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryId: "3501531531",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "304140121",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryId: "3501531531",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "304140121",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryId: "3501531531",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "304140121",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryId: "3501531531",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "304140121",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryId: "3501531531",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "304140121",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryId: "3501531531",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "304140121",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryId: "3501531531",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "347275235",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryId: "3501531531",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "304140121",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryId: "3501531531",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "304140121",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryId: "3501531531",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "304140121",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryId: "3501531531",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "304140121",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryId: "3501531531",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "304140121",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryId: "3501531531",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "304140121",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryId: "3501531531",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "304140121",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryId: "3501531531",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "347275235",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryId: "3501531531",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "304140121",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryId: "3501531531",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "304140121",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryId: "3501531531",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "304140121",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryId: "3501531531",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "304140121",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryId: "3501531531",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "304140121",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryId: "3501531531",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "304140121",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryId: "3501531531",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "304140121",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryId: "3501531531",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "347275235",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryId: "3501531531",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "304140121",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryId: "3501531531",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "304140121",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryId: "3501531531",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "304140121",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryId: "3501531531",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "304140121",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryId: "3501531531",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "304140121",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryId: "3501531531",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "304140121",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryId: "3501531531",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "304140121",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryId: "3501531531",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "347275235",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryId: "3501531531",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "304140121",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryId: "3501531531",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "304140121",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryId: "3501531531",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "304140121",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryId: "3501531531",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "304140121",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryId: "3501531531",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "304140121",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryId: "3501531531",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "304140121",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryId: "3501531531",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "304140121",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryId: "3501531531",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "347275235",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryId: "3501531531",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "304140121",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryId: "3501531531",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "304140121",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryId: "3501531531",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "304140121",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryId: "3501531531",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "304140121",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryId: "3501531531",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "304140121",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryId: "3501531531",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "304140121",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryId: "3501531531",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "304140121",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryId: "3501531531",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "347275235",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryId: "3501531531",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "304140121",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryId: "3501531531",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "304140121",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryId: "3501531531",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "304140121",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryId: "3501531531",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "304140121",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryId: "3501531531",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "304140121",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryId: "3501531531",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "304140121",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryId: "3501531531",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "304140121",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryId: "3501531531",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "347275235",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryId: "3501531531",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "304140121",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryId: "3501531531",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "304140121",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryId: "3501531531",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "304140121",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryId: "3501531531",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "304140121",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryId: "3501531531",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "304140121",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryId: "3501531531",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "304140121",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryId: "3501531531",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "304140121",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryId: "3501531531",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "347275235",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryId: "3501531531",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "304140121",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryId: "3501531531",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "304140121",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryId: "3501531531",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "304140121",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryId: "3501531531",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "304140123",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
  {
    deliveryId: "304140121",
    invoiceNumber: "3403503252RT",
    amount: 81.0,
    codAmount: 0,
    comment: "Redeliver*did not need*35159315931DT#R#*123",
    creationDate: "09/20/2022",
    customerAddress: "123 lane drive",
    customerCity: "Houston",
    customerName: "Dili Auto Parts",
    customerState: "Texas",
    customerZip: "77064",
    deliveryDate: "09/25/2022",
    deliveryId: "3501531531",
    deliveryType: "Return",
    destinationName: "Fort Buildsworth",
    isCod: false,
    pieceCount: 3,
    route: "ABC-LOC-213",
    status: "In Transit",
    trackingNumbers: null,
  },
];
//amount
//codAmount
//comment
//creationDate
//customerAddress
//customerCity
//customerName
//customerPhoneNumber
//customerState
//customerZip
//deliveryDate
//deliveryId
//deliveryType
//destinationName
//invoiceNumber
//isCod
//pieceCount
//route
//status
//trackingNumbers

const OrderHistoryRework1 = ({ setLoading }) => {
  //third party hooks
  const history = useHistory();

  //------------Modal Section-------------------------//
  //Deciding to make a custom modal specific to the search template instead of having a generic one.
  const [modalContent, setModalContent] = useState({
    title: "",
    body: "",
    footer: "",
    confirmClick: null,
  });
  const [showModal, setShowModal] = useState(false);
  const handleShowModal = () => {
    setShowModal(true);
  };
  const handleCloseModal = () => {
    setShowModal(false);
  };

  //------------End Modal Section-------------------------//

  //Effects, State, Change Handlers
  const [orders, setOrders] = useState([]);

  const [dateRange, setDateRange] = useState({
    datestart: dateFormat(dateAdd(new Date(), { days: -15 }), "yyyy-MM-dd"),
    dateend: dateFormat(dateAdd(new Date(), { days: 5 }), "yyyy-MM-dd"),
  });
  const handleChangeDateRange = (e) => {
    console.log(e.target.name);
    console.log(e.target.value);
    setDateRange({ ...dateRange, [e.target.name]: e.target.value });
    console.log(dateRange);
  };

  //view style------------------------------------------------------------------------------
  const [viewStyle, setViewStyle] = useState(
    localStorage.getItem("order-history-viewstyle") ?? "list"
  ); //list, table, cards
  const handleChangeViewStyle = (viewStyleName) => {
    setViewStyle(viewStyleName);
    localStorage.setItem("order-history-viewstyle", viewStyleName);
  };

  //search templates-------------------------------------------------------------------------
  const [filterTemplates, setFilterTemplates] = useState([]);
  //redo this to use local storage, then redo again to use database after discussing *****
  const saveFilterTemplate = () => {
    //make sure one with the same name does not exist ****** validation *******?
    console.log(nameForSavingFilterTemplate);
    setFilterTemplates([
      ...filterTemplates,
      { templateName: nameForSavingFilterTemplate, ...filterValues },
    ]);
  };
  const [nameForSavingFilterTemplate, setNameForSavingFilterTemplate] =
    useState("");
  const handleChangeSavingTemplateName = (e) => {
    console.log(e.target.value);
    console.log(nameForSavingFilterTemplate);
    setNameForSavingFilterTemplate(e.target.value);
  };
  const showSaveFilterTemplateModal = () => {
    setModalContent({
      title: "Save Filter Template",
      body: (
        <div>
          <ul className="list-group">
            {/* Programmatically generate list of object key value pairs for display, but the object keys are camel cased so they don't look that good. Could probably change the keys to look nice but idk if that is good practice.  */}
            {Object.keys(filterValues).map((key) => {
              return (
                <li
                  key={key + "-" + filterValues[key]}
                  className="list-group-item"
                >
                  <div>{key}:</div>
                  <div>{filterValues[key]}</div>
                </li>
              );
            })}
          </ul>
          <p>Saving current filters to template.</p>
          <label>Template Name</label>
          <input
            type="text"
            // value={nameForSavingFilterTemplate} I don't fully understand why this doesn't work... modal stops updating if we try to sync state...
            className="form-control"
            onChange={handleChangeSavingTemplateName}
          />
        </div>
      ),
      footer: (
        <>
          <button
            className="btn btn-secondary"
            type="button"
            onClick={handleCloseModal}
          >
            Cancel
          </button>
          <button
            className="btn btn-primary"
            type="button"
            onClick={saveFilterTemplate}
          >
            Save
          </button>
        </>
      ),
      confirmClick: () => {
        alert("LOL");
      },
    });
    handleShowModal();
  };

  //order id/barcode id filter
  // const [orderIdFilter, setOrderIdFilter] = useState("");
  // const handleChangeOrderIdFilter = (e) => {
  //   setOrderIdFilter(e.target.value);
  // };
  // const [customerFilter, setCustomerFilter] = useState("");
  // const handleChangeCustomerFilter = (e) => {
  //   setCustomerFilter(e.target.value);
  // };

  const initialFilterValues = {
    orderId: "",
    invoiceNumber: "",
    customerName: "",
    customerCity: "",
    customerState: "",
    customerZip: "",
    route: "",
    codType: "",
    deliveryType: "",
    status: "",
  };

  const [filterValues, setFilterValues] = useState({ ...initialFilterValues });
  const handleResetFilters = () => {
    setFilterValues({ ...initialFilterValues });
  };
  const filterDropdownOptions = useMemo(() => {
    // console.log("drop down options getter running");
    const codOptionsSet = new Set();
    const deliveryTypeSet = new Set();
    const statusSet = new Set();
    for (let i = 0; i < orders.length; i++) {
      codOptionsSet.add(orders[i].isCod ? "Yes" : "No");
      deliveryTypeSet.add(orders[i].deliveryType);
      statusSet.add(orders[i].status);
    }
    return { codOptionsSet, deliveryTypeSet, statusSet };
  }, [orders]);

  const handleChangeFilterValues = (e) => {
    setFilterValues({
      ...filterValues,
      [e.target.name]: e.target.value,
    });
    setPage(1);
    setPageSearchValue(1);
  };

  //RESULTS PROCESSING
  //FILTER, SORT, PAGINATE, ETC

  // const tableData

  const filteredOrders = orders.filter((order) => {
    // console.log(order.deliveryId);
    // console.log(typeof order.deliveryId);
    // console.log(filterValues.route.toLowerCase);
    return (
      order.deliveryId.toString().includes(filterValues.orderId) &&
      order.customerName
        .toLowerCase()
        .includes(filterValues.customerName.toLowerCase()) &&
      order.invoiceNumber.includes(filterValues.invoiceNumber) &&
      order.route.toLowerCase().includes(filterValues.route.toLowerCase()) &&
      (filterValues.codType === "" ||
        order.isCod === (filterValues.codType === "Yes" ? true : false)) &&
      (filterValues.deliveryType === "" ||
        order.deliveryType === filterValues.deliveryType) &&
      (filterValues.status === "" || order.status === filterValues.status)
    );
  });

  //Sorting
  //sorting by date doesn't work yet *************!!!!!!!*************
  const [sortBy, setSortBy] = useState("creationDate");
  const [sortByDesc, setSortByDesc] = useState(true);
  const sortedOrders = filteredOrders.sort((a, b) => {
    if (sortByDesc) {
      return b[sortBy] - a[sortBy];
    } else {
      return a[sortBy] - b[sortBy];
    }
  });

  console.log(sortedOrders);
  const handleChangeSortBy = (e) => {
    setSortBy(e.target.value);
    console.log(e.target.value);
  };
  const handleToggleSortByOrder = (e) => {
    setSortByDesc((prevSortByDesc) => {
      console.log(!prevSortByDesc);
      return !prevSortByDesc;
    });
  };

  //Pagination
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const totalPages = Math.ceil(filteredOrders.length / pageSize);
  let pageOptions = [];
  for (let i = 0; i < totalPages; i++) {
    pageOptions.push(i);
  }
  //slice will do a shallow copy ***** probably not a problem as we will not be modifying the orders on this page.
  const ordersToDisplay = sortedOrders.slice(
    (page - 1) * pageSize,
    page * pageSize
  );

  const goToPage = (pageToGo) => {
    console.log("go to page?");
    console.log(pageToGo);
    console.log(page);
    console.log(totalPages);
    if (pageToGo >= 1 && pageToGo <= totalPages) {
      setPage(pageToGo);
      setPageSearchValue(pageToGo);
      console.log("NAVIGATED");
    }
  };

  const handleChangePageSize = (e) => {
    setPageSize(e.target.value);
  };
  //page search
  const [pageSearchValue, setPageSearchValue] = useState(1);
  const handlePageSearchChange = (e) => {
    //if a non-number is entered, return;
    if (e.target.value === "") {
      goToPage(1);
      setPageSearchValue("");
      return;
    }
    if (parseInt(e.target.value) === NaN) {
      return;
    }

    const pageToGo = parseInt(e.target.value);
    if (pageToGo > totalPages) {
      goToPage(totalPages);
      setPageSearchValue(totalPages);
      return;
    }

    //we already check to see if the number is within the amount of pages we have in this function so no need to check again here.
    goToPage(pageToGo);
    setPageSearchValue(pageToGo);
  };

  //End Pagination
  //search by order/barcode toggle
  const [searchByBarcode, setSearchByBarcode] = useState(false);
  const handleSearchTypeChange = (e) => {
    setSearchByBarcode(e.target.checked);
    console.log(e.target.checked);
  };

  const fetchOrders = async () => {
    setLoading(true);
    try {
      const { data: foundOrders } = await getDeliveryHistory(
        dateRange.datestart,
        dateRange.dateend,
        isClient()
      );
      // const response = await axios.get(
      //   "http://localhost:7000/testserver-order-history-rework-ORDERS",
      //   {
      //     params: {
      //       from: dateRange.datestart,
      //       to: dateRange.dateend,
      //     },
      //   }
      // );
      // const foundOrders = response.data;
      console.log(foundOrders);
      setOrders(foundOrders);
      setLoading(false);
    } catch (ex) {
      setLoading(false);
      handleApiError(ex, history);
    }
  };

  useEffect(() => {
    fetchOrders();
  }, [history, setLoading]);

  // console.log("hi");
  // console.log(dateRange);
  // console.log("hi");
  return (
    <div className="order-history-page-container">
      <Helmet>
        <title>Order History - {defaultTitle} </title>
      </Helmet>
      <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>{modalContent.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{modalContent.body}</Modal.Body>
        <Modal.Footer>{modalContent.footer}</Modal.Footer>
      </Modal>
      <div className="sidebar p-3">
        <div className="row mb-4">
          <div className="col-12 text-20">Search</div>
          <div className="col-12 form-group">
            <label>Start Date</label>
            <input
              className="form-control"
              type="date"
              name="datestart"
              value={dateRange.datestart}
              onChange={handleChangeDateRange}
            ></input>
          </div>
          <div className="col-12 form-group">
            <label>End Date</label>
            <input
              className="form-control"
              type="date"
              name="dateend"
              value={dateRange.dateend}
              onChange={handleChangeDateRange}
            ></input>
          </div>
          <div className="col-12">
            <button className="btn btn-primary w-100" onClick={fetchOrders}>
              Search Orders
            </button>
          </div>
        </div>
        <div className="row">
          <div className="col-12 text-20">
            <div className="row">
              <div className="col-12">
                Filter{" "}
                <BsArrowRepeat
                  className="mb-1 reset-icon-button"
                  onClick={handleResetFilters}
                />
              </div>
              {/* <div className="col-6 text-right">
                <BsPlusSquare onClick={showSaveFilterTemplateModal} />
              </div> */}
            </div>
          </div>
          <div className="col-12">
            <div className="row">
              <div className="col-8">
                <label>Filter Templates</label>
              </div>
              <div className="col-4 text-right">
                <BsPlusSquare onClick={showSaveFilterTemplateModal} />
              </div>
            </div>
            <div className="search-template-container">
              {filterTemplates.map((filterTemplate) => {
                return <div>{filterTemplate.templateName}</div>;
              })}
            </div>
          </div>
          <div className="col-12 d-flex">
            <label className="mr-2">
              {searchByBarcode ? "Barcode" : "Order Id"}
            </label>
            <div className="custom-control custom-switch">
              <input
                type="checkbox"
                className="custom-control-input"
                onChange={handleSearchTypeChange}
                id="customSwitch1"
              />
              <label
                className="custom-control-label"
                htmlFor="customSwitch1"
              ></label>
            </div>
          </div>
          <div className="col-12 form-group">
            <input
              className="form-control"
              name="orderId"
              value={filterValues.orderId}
              onChange={handleChangeFilterValues}
              placeholder={
                searchByBarcode ? "Search By Barcode" : "Search By Order Id"
              }
            ></input>
          </div>

          <div className="col-12 form-group">
            <label>Invoice</label>
            <input
              className="form-control"
              name="invoiceNumber"
              value={filterValues.invoiceNumber}
              onChange={handleChangeFilterValues}
              placeholder="Invoice Number"
            ></input>
          </div>
          <div className="col-12 form-group">
            <label>Customer</label>
            <input
              className="form-control"
              name="customerName"
              value={filterValues.customerName}
              onChange={handleChangeFilterValues}
              placeholder="Customer"
            ></input>
          </div>
          <div className="col-12 form-group">
            <label>Route</label>
            <input
              className="form-control"
              name="route"
              value={filterValues.route}
              onChange={handleChangeFilterValues}
              placeholder="Route"
            ></input>
          </div>
          <div className="col-12 form-group">
            <label>COD</label>
            <select
              className="form-control"
              name="codType"
              value={filterValues.codType}
              onChange={handleChangeFilterValues}
            >
              <option value="">All</option>
              {[...filterDropdownOptions.codOptionsSet].map((option) => {
                return (
                  <option key={option} value={option}>
                    {option}
                  </option>
                );
              })}
            </select>
          </div>
          <div className="col-12 form-group">
            <label>Delivery Type</label>
            <select
              className="form-control"
              name="deliveryType"
              value={filterValues.deliveryType}
              onChange={handleChangeFilterValues}
            >
              <option value="">All</option>
              {[...filterDropdownOptions.deliveryTypeSet].map((option) => {
                return (
                  <option key={option} value={option}>
                    {option}
                  </option>
                );
              })}
            </select>
          </div>
          <div className="col-12 form-group">
            <label>Status</label>
            <select
              className="form-control"
              name="status"
              value={filterValues.status}
              onChange={handleChangeFilterValues}
            >
              <option value="">All</option>
              {[...filterDropdownOptions.statusSet].map((option) => {
                return (
                  <option key={option} value={option}>
                    {option}
                  </option>
                );
              })}
            </select>
          </div>
        </div>
      </div>
      {/*================================================== BEGIN SEARCH RESULTS ==================================================== */}
      <div className="order-history-results-container">
        <div className="row">
          {/* this is for comparing paginated and unpaginated list, get rid of this row and the column in the below line */}
          <div className="container col-12">
            <div className="row">
              <div className="col-12">
                {/* ✔ */}
                To do:
                <ul>
                  <li>
                    ***Order Details(Parcel and Tracking Info)
                    Page/(Expand/Collapse)***
                  </li>
                  <li>***Search By Barcode***</li>
                  <li>
                    ***SEARCH BY ORDER ID (NOT FILTER)***
                    <ul>
                      <li>
                        Will Probably make a new tab for the sidebar for this
                      </li>
                      <li>
                        Maybe a new tab to search by all the same fields as the
                        filters regardless of dates?
                      </li>
                      <li>Maybe want to make seperate pages?</li>
                      <li>
                        maybe just another order id search field above the dates
                      </li>
                    </ul>
                  </li>
                  <li>
                    ****Change Sidebar to not be fixed, or have its own
                    scrollbar or something as right now when we add more fields
                    they will be unreachable. (play with some design ideas)****
                  </li>
                  <li>Work on Design</li>
                  <li>Order Action Menu</li>
                  <li>Add rest of filters ✔</li>
                  <li>Implement different view styles </li>
                  <li>
                    Finish adding pagination (go to page and page size dropdown)
                  </li>
                  <li>
                    Implement Sorting (Planning to have a dropdown to select
                    which field to sort by, maybe the condensed view can have
                    table style arrows like ismael's version)
                  </li>
                  <li>
                    Search Templates (localstorage or tie to account(db)? Can we
                    do that if we switch entirely to CXT
                    <ul>
                      <li>
                        camel case formatter... (alternatives are having spaces
                        in the key names or hard coding the filter list in the
                        modal
                      </li>
                      <li>
                        Switch to hard coded search template save modal - trying
                        to add an input field to the modal dynamincally messes
                        up with setting state correctly for some reason (it gets
                        stuck with the initial state the way I'm doing it.
                        probably a way to get this to work but a hard coded
                        modal is fine.)
                      </li>
                    </ul>
                  </li>

                  <li>
                    Tabs for Parcel/COD/POD info, etc when clicking on order
                    details
                  </li>
                  <li>
                    New Page version (maybe this is the way to go for mobile);
                  </li>
                  <li>Jump to Page Field ✔</li>
                  <li>
                    Work On Mobile Design
                    <ul>
                      <li>
                        Change Sidebar to "Filter and Sort" Button right above
                        list on mobile/tablet
                      </li>
                    </ul>
                  </li>
                  <li>
                    List Toolbar
                    <ul>
                      <li>Save last view style to local storage ✔</li>
                      <li>Sort Dropdown</li>
                      <li>
                        Bulk Print Button
                        <ul>
                          <li>
                            <s>By Customer/Destination Address</s> NO
                          </li>
                          <li>
                            By current filtered results, add modal that makes
                            them type "YES" and tell them they have to take care
                            of putting the labels on the right box, the backend
                            will save this to the database, client id,
                            userid/username, and timestamp.
                          </li>
                          <li>
                            Maybe by selection (would have to add checkboxes on
                            each row, or stay highlighted on click (may conflict
                            with expansion style details))
                          </li>
                        </ul>
                      </li>
                      <li>
                        Settings/Gear icon for:
                        <ul>
                          <li>enabling/disabling columns</li>
                          <li>Maybe reordering columns</li>
                        </ul>
                      </li>
                    </ul>
                  </li>
                  <li>
                    Sticky header for table that is also responsive (-GOING WITH
                    STICKY HEADER, and SWAPPING TO LIST ONLY ON SMALLER SCREENS)
                  </li>
                </ul>
              </div>
              <div className="col-12 text-right px-0">
                <span className="mx-3">Total Results: {orders.length}</span>
                <span className="mx-3">
                  {" "}
                  Current Filter Set: {filteredOrders.length}
                </span>
                {/* <span className="ml-3"> Pages: {totalPages}</span> */}
              </div>
              {/* view styles, list, table, cards */}
              <div
                className="col-12 mb-3 mt-2 d-flex justify-content-end"
                id="list-toolbar"
              >
                <div
                  className="d-flex align-items-center"
                  style={{ width: "fit-content" }}
                >
                  Sort by
                  <select
                    className="form-control mr-3 ml-2"
                    style={{ width: "fit-content" }}
                    onChange={handleChangeSortBy}
                  >
                    <option value="deliveryDate">Delivery Date</option>
                    <option value="creationDate">Creation Date</option>
                    <option value="pieceCount">Pieces</option>
                    <option value="codAmount">Cod Amount</option>
                  </select>
                  <button
                    className="btn btn-light mr-3"
                    style={{
                      boxShadow: "0px 0px 7px rgb(0,0,0,.2)",
                      borderRadius: "4px",
                      width: "70px",
                    }}
                    onClick={handleToggleSortByOrder}
                  >
                    {sortByDesc ? "Desc" : "Asc"}
                  </button>
                  <div
                    className="btn-group"
                    style={{
                      boxShadow: "0px 0px 7px rgb(0,0,0,.2)",
                      borderRadius: "4px",
                    }}
                  >
                    <button
                      type="button"
                      className={
                        "btn shadow-none" +
                        (viewStyle === "table" ? " btn-primary" : "")
                      }
                      onClick={() => handleChangeViewStyle("table")} // can also do this the e.target.name way, but if you click on something inside the button, e.target is that instead and won't have the button name. probably can disable pointer events on the things inside, not sure, decided to go this way.
                    >
                      <BsCardList />
                    </button>
                    <button
                      type="button"
                      className={
                        "btn shadow-none" +
                        (viewStyle === "list" ? " btn-primary" : "")
                      }
                      onClick={() => handleChangeViewStyle("list")}
                    >
                      <BsList />
                    </button>
                    <button
                      type="button"
                      className={
                        "btn shadow-none" +
                        (viewStyle === "cards" ? " btn-primary" : "")
                      }
                      onClick={() => handleChangeViewStyle("cards")}
                    >
                      <BsFillGridFill />
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <OrderHistoryList orders={ordersToDisplay} viewType={viewStyle} />
            {/* pagination */}
            {totalPages > 0 && (
              <div className="d-flex justify-content-between px-2">
                <div className="d-flex">
                  <div>
                    <input
                      className="form-control mr-2"
                      onChange={handlePageSearchChange}
                      value={pageSearchValue}
                      style={{ width: "100px" }}
                    ></input>
                    <small className="text-note pl-1">
                      Page {page} / {totalPages}
                    </small>
                  </div>
                  <select
                    className="form-control"
                    onChange={handleChangePageSize}
                    style={{ width: "fit-content" }}
                  >
                    <option value={10}>10 per page</option>
                    <option value={20}>20 per page</option>
                    <option value={50}>50 per page</option>
                    <option value={100}>100 per page</option>
                  </select>
                </div>
                <ul className="pagination">
                  <li
                    className="page-item"
                    disabled={page === 1}
                    onClick={() => {
                      goToPage(page - 1);
                    }}
                  >
                    <button className="page-link">Previous</button>
                  </li>
                  {pageOptions
                    .slice(
                      page - 1 >= 3
                        ? page - 1 >= pageOptions.length - 2
                          ? pageOptions.length - 5
                          : page - 3
                        : 0,
                      page - 1 >= 3 ? page + 2 : 5
                    )
                    .map((pageNumber) => {
                      // console.log(pageNumber);
                      return (
                        <li
                          key={pageNumber}
                          className={
                            "page-item " +
                            (page === pageNumber + 1 ? "active " : "")
                          }
                          onClick={() => {
                            goToPage(pageNumber + 1);
                          }}
                        >
                          <button className="page-link">
                            {pageNumber + 1}
                          </button>
                        </li>
                      );
                    })}
                  <li
                    className="page-item"
                    onClick={() => {
                      goToPage(page + 1);
                    }}
                  >
                    <button className="page-link">Next</button>
                  </li>
                </ul>
              </div>
            )}
          </div>
          {/* <div className="container col-6">
          <div className="row">
            <div className="col-12 text-right">
              Search Results: {filteredOrders.length}
            </div>
          </div>
          <div className="order-history-results-list">
            <div className="order-history-result-card">yo</div>
            {filteredOrders.map((order) => {
              return (
                <div className="order-history-result-card row">
                  <div className="col-md-4 red">
                    <span className="text-20">Order </span>
                    <span className="text-20">{order.deliveryId}</span>
                    <div>
                      <span>Invoice {order.invoiceNumber}</span>
                    </div>
                  </div>
                  <div className="col-md-4 green"></div>
                  <div className="col-md-4 purple"></div>
                </div>
              );
            })}
          </div>
        </div> */}
        </div>
      </div>
    </div>
  );
};

export default OrderHistoryRework1;
